var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar",style:({ backgroundColor: _vm.backgroundColor })},[_c('div',{staticClass:"progress-bar-inner",style:({ width: `${_vm.percentage}%`, background: `linear-gradient(90deg, ${_vm.progressColor.start} 0%, ${_vm.progressColor.end} 100%)` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }